import { Language, SUPPORTED_LANGUAGES } from '@core/enums/language';
import { LANGUAGE_VARIANTS } from '../constants/language';

export const FOCUS_MAIN_STATE_KEY = 'focusMain';

export function getNavigatorLanguage(): Language | null {
  const navigatorLanguage = navigator.language;
  for (const supportedLanguage of SUPPORTED_LANGUAGES) {
    if (LANGUAGE_VARIANTS[supportedLanguage].includes(navigatorLanguage)) {
      return supportedLanguage;
    }
  }
  return null;
}
